import {getPlayedTime} from 'app/components/tv/getPlayedTime';
import {getElementFromSessionStorage, setElementToSessionStorage} from 'app/helpers/webStorageUtility';

export const DEFAULT_AD_CREDITS = 80;
const STORAGE_KEY = 'adCredits';

export const updateAdCredits = (playedTimeRanges, startSec) => {
  const adCredits = getAdCredits();
  const playedTime = Math.floor(getPlayedTime(playedTimeRanges, startSec));
  const newAdCredits = adCredits - playedTime;
  setElementToSessionStorage(STORAGE_KEY, String(newAdCredits));
};

const getAdCredits = () => {
  return Number(getElementFromSessionStorage(STORAGE_KEY));
};

export const setAdCredits = (credits = DEFAULT_AD_CREDITS) => {
  setElementToSessionStorage(STORAGE_KEY, String(credits));
};

export const checkPlayAd = () => {
  const adCredits = getAdCredits();
  return !(adCredits && adCredits <= DEFAULT_AD_CREDITS && adCredits > 0);
};
